import * as React from 'react';

import {useTranslation} from 'react-i18next';
import {CheckboxButton} from '../../../components/buttons/checkbox-button/checkbox-button';

export function AlertsFilterTransportsComponent(props: any) {
    const {t} = useTranslation();
    // Function que comproba si esta o no seleccionat el filtre
    const activeFilter = (slug: string) => {
        let filterOK = false;
        if (props.filters.length > 0) {
            props.filters.forEach((filter: any) => {
                if (filter.slug == slug) {
                    filterOK = true;
                }
            });
        } else {
            filterOK = true;
        }

        return filterOK;
    };

    return (<div className="alerts-filters-container">
        <div className="alert-filter-section">{t('translation:misc_alert_filter_transport_section')}</div>
        {props.filterOptions.map((op: any, i: number) =>
            <div key={i}>
                <CheckboxButton
                    isChecked={activeFilter(op.slug)}
                    label={op.name}
                    value={op.slug}
                    changeActiveFilter={props.changeActiveFilter}
                    filterOption={op}
                />
            </div>)}
    </div>
    );
}
